/** Geräte-Erkennung: Handy/Touch vs. Desktop. Reine Entscheidung (testbar) + dünner Wrapper,
 *  der die echten Browser-Signale ausliest. Für „Kamera-Foto-Buttons (Handy) vs. QR-Weg (PC)". */

export function isMobileFromSignals(s: {
  uaDataMobile?: boolean;
  pointerCoarse?: boolean;
  maxTouchPoints?: number;
  userAgent?: string;
}): boolean {
  // 1) Explizites Client-Hint (Chrome/Edge) hat Vorrang.
  if (typeof s.uaDataMobile === 'boolean') return s.uaDataMobile;
  // 2) User-Agent-Heuristik.
  const uaMobile = /Android|iPhone|iPad|iPod|Mobile|Windows Phone/i.test(s.userAgent ?? '');
  // 3) Touch-Primärgerät (fängt u.a. iPads, die sich als „Macintosh" ausgeben).
  const touch = (s.maxTouchPoints ?? 0) > 0;
  return uaMobile || (!!s.pointerCoarse && touch);
}

export function isMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const nav = navigator as any;
  return isMobileFromSignals({
    uaDataMobile: nav.userAgentData?.mobile,
    pointerCoarse: typeof window !== 'undefined' ? window.matchMedia?.('(pointer: coarse)')?.matches : undefined,
    maxTouchPoints: nav.maxTouchPoints,
    userAgent: nav.userAgent,
  });
}
